import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from "react";
import { Typography, numeral, setLocale, makeStyles } from "../../..";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    paid: {
      color: theme.palette.primary.main
    },
    overdue: {
      color: theme.palette.error.main
    },
    pending: {
      color: theme.palette.pending.main
    },
    icon: {
      width: "60px",
      height: "auto"
    },
    positive: {
      color: theme.palette.primary.main
    },
    negative: {
      color: theme.palette.error.main
    },
    charts: {
      display: "flex",
      padding: "0px 5px 20px"
    },
    justifiySpaceBetween: {
      "justify-content": "space-between"
    },
    justifiySpaceAround: {
      "justify-content": "space-around"
    },
    fcolumn: {
      "flex-direction": "column",
      width: "100%"
    },
    content: {
      "text-align": "center",
      margin: "10px 5px",
      "font-weight": "400"
    },
    box: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d",
      padding: "5px"
    },
    total: {
      background: "#8080805e"
    },
    variationContainer: {
      display: "flex",
      alignItems: "flex-end",
      "flex-direction": "column"
    },
    percentage: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.primary.main
    }
  };
});

var BoxNumber = function BoxNumber(_ref) {
  var value = _ref.value,
      variant = _ref.variant,
      variation = _ref.variation,
      percentage = _ref.percentage,
      title = _ref.title,
      caption = _ref.caption,
      total = _ref.total,
      locale = _ref.locale,
      number = _ref.number,
      props = _objectWithoutProperties(_ref, ["value", "variant", "variation", "percentage", "title", "caption", "total", "locale", "number"]);

  var classes = useStyles();
  useEffect(function () {
    setLocale(locale);
  }, [locale]);

  var content = function content() {
    switch (variant) {
      case "variation":
        return variation !== false && /*#__PURE__*/React.createElement("div", {
          className: classes.variationContainer
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.percentage
        }, variation > 0 ? /*#__PURE__*/React.createElement(ArrowDropUpIcon, {
          className: [classes.positive, classes.icon].join(" ")
        }) : /*#__PURE__*/React.createElement(ArrowDropDownIcon, {
          className: [classes.negative, classes.icon].join(" ")
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: variation > 0 ? classes.positive : classes.negative
        }, !isNaN(variation) ? "".concat(variation, "%") : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          style: {
            "margin-top": "-19px",
            color: variation > 0 ? "#77ffb5" : "#E95A58"
          }
        }, "vs ", caption));

      case "percentage":
        return /*#__PURE__*/React.createElement("div", {
          className: classes.percentage
        }, !isNaN(percentage) && /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: percentage >= 0 ? classes.positive : classes.negative
        }, "".concat(percentage, " %")));
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    className: total ? [classes.total, classes.box].join(" ") : classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h6"
  }, number ? value : numeral(value).format("0,0 $")), content()));
};

export { BoxNumber };